import { useEffect, useState } from "react";
import LogoMark from "../Logo";

const WA = "https://wa.me/917995495312?text=Hi%20Aria";

const Nav = () => {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const onScroll = () => {
      // Hero is roughly 100vh; switch from dark to light after.
      const heroHeight = window.innerHeight - 80;
      // Find current section bg by checking sections in viewport
      const sections = document.querySelectorAll("[data-bg]");
      let current = "dark";
      sections.forEach((s) => {
        const r = s.getBoundingClientRect();
        if (r.top <= 60 && r.bottom >= 60) {
          const bg = s.getAttribute("data-bg");
          current = (bg === "black" || bg === "dark") ? "dark" : "light";
        }
      });
      if (window.scrollY < heroHeight) current = "dark";
      setTheme(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav className={`nav ${theme}`} data-testid="main-nav">
      <div className="nav-inner">
        <button className="nav-link nav-brand" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="nav-logo">
          <LogoMark size={32} className="nav-logo-mark" />
          <span className="nav-logo">Aria<span className="dot">.</span></span>
        </button>
        <div className="nav-links">
          <button className="nav-link" onClick={() => go("solutions")} data-testid="nav-solutions">Solutions</button>
          <button className="nav-link" onClick={() => go("industries")} data-testid="nav-industries">Industries</button>
          <button className="nav-link" onClick={() => go("workforce")} data-testid="nav-workforce">AI Workforce</button>
          <button className="nav-link" onClick={() => go("why-aria")} data-testid="nav-why">Why Aria</button>
          <button className="nav-link" onClick={() => go("pricing")} data-testid="nav-pricing">Pricing</button>
        </div>
        <a href={WA} target="_blank" rel="noreferrer" className="nav-cta" data-testid="nav-cta-wa">
          Book free call →
        </a>
      </div>
    </nav>
  );
};

export default Nav;
